<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="showState && $route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="showState && !$route.meta.keepAlive" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getCategoryTree, getFreezingModeList, articleCategoryList, buryingPoint, getUserDetailsById } from "./request/api";
export default {
  name: "App",
  data () {
    return {
      showState: true
    };
  },
  provide () {
    return {
      reload: this.reload
    };
  },
  methods: {
    reload () {
      this.showState = false;
      this.$nextTick(() => {
        this.showState = true;
      });
    },
    // 主题市场获取
    getCategoryTree: async function () {
      try {
        const result = await getCategoryTree();
        if (result.code == 200 && result.success) {
          this.$store.commit("addCategoryTree", result.result);
        }
      } catch (error) {
        console.log("error", error);
      }
    },
    //获取冷冻方式列表
    getFreezingModeList: async function () {
      try {
        const result = await getFreezingModeList();
        if (result.code == 200 && result.success) {
          this.$store.commit("addFreezingModeList", result.result);
        }
      } catch (error) {
        console.log("error", error);
      }
    },
    articleCategoryRequest: async function () {
      try {
        const result = await articleCategoryList();
        if (result.code == 200 && result.success) {
          this.$store.commit("addArticleCategory", result.result);
        }
      } catch (error) {
        console.log("error", error);
      }
    },
    async getUserDetailsByIdFunc () {
      try {
        let result = await getUserDetailsById();
        if (result.code == 200 && result.success) {
          this.$store.commit("setUser", result.result)
        } else {
          console.log("开户信息查询失败");
        }
      } catch (error) {
        console.log("开户信息查询异常", error);
      }
    },
  },
  watch: {
    '$route': {
      handler: async function (val) {
        try {
          let correlationType = ''
          if (val.path == '/productDetail' || val.path == '/overseas/detail') {
            correlationType = 1
          } else if (val.path == '/newsNew/detail') {
            correlationType = 2
          } else {
            correlationType = ''
          }
          const result = await buryingPoint({
            source: 2,
            type: 1,
            correlationId: val.path == '/productDetail' || val.path == '/overseas/detail' || val.path == '/newsNew/detail' ? val.query.id : '',
            correlationType: correlationType
          });
          if (this.$store.state.userInfo.user_name) {
            console.log('APPPPPPP')
            this.getUserDetailsByIdFunc()
          }

        } catch (error) {
          console.log("error", error);
        }
        // if (val.path == "/screen") {
        //   document.body.classList.remove('ui-drawer-pop')
        // }



      },
      deep: true,
      immediate: true
    },
    local: {
      handler (val) {
        this.$store.commit("addCategoryTree", []);
        this.getCategoryTree()
        this.getFreezingModeList()
        this.articleCategoryRequest()

      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    ...mapState({
      local: state => state.local,
    }),
  },
  async created () {
    await this.getCategoryTree()
    await this.getFreezingModeList()
    await this.articleCategoryRequest()
  }
};
</script>

<style lang="scss">
.el-select .el-select-dropdown {
  transform: translateX(-5px);
}
* {
  -webkit-user-select: text;
}
@import './styles/reset.css';
@import './styles/reset2.css';
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333333;
  font-weight: 400;
  width: 100%;
  height: 100%;
  & > div {
    width: 100%;
    height: 100%;
  }
  /* background-color: #f6f6f6; */
}
.el-carousel__container {
  width: 100% !important;
  height: 100% !important;
}
.padding {
  padding-right: 37px !important;
}
.el-carousel__item {
  width: 100% !important;
  height: 100% !important;
}

.el-carousel__indicators--horizontal {
  width: auto !important;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}
.el-carousel__button {
  height: 10px !important;
  width: 10px !important;
  border-radius: 10px !important;
  opacity: 1 !important;
  background: #fff !important;
}
.is-active .el-carousel__button {
  width: 24px !important;
  background-color: #005293 !important;
}

.el-form-item__label {
  font-size: 14px !important;
  font-weight: normal !important;
  color: #333333 !important;
}
.el-pagination {
  display: flex;
  justify-content: center;
  padding: 50px 0;
}
.el-pagination .btn-prev,
.el-pagination .btn-next,
.el-pagination li {
  width: 24px !important;
  height: 24px !important;
  line-height: 24px !important;
  text-align: center;
  margin: 0 10px !important;
  background: #ffffff !important;
  border-radius: 2px !important;
  opacity: 1;
  opacity: 1;
  border: 1px solid #dcdee2;
  box-sizing: border-box;

  font-size: 12px !important;
  font-family: Microsoft YaHei UI-Regular, Microsoft YaHei UI;
  font-weight: 400;
  color: #808695;
  min-width: 24px !important;
}
.el-pager li.active + li {
  border-left: 1px solid #dcdee2 !important;
}
.el-pagination .btn-next .el-icon,
.el-pagination .btn-prev .el-icon {
  display: block;
  font-size: 12px !important;
  font-weight: 0;
}
.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #005293;
}
.el-pagination.is-background .el-pager li.active:hover {
  color: #fff;
}
.el-pagination li.active,
.el-pagination.is-background .el-pager li:not(.disabled).active {
  border-color: #296df1 !important;
  color: #296df1 !important;
  // border: 0;
}

.el-pager .more::before {
  line-height: 24px !important;
}
.el-dialog {
  border-radius: 14px !important;
}
.el-message-box__title {
  font-size: 16px;
}
.el-message-box {
  // width: 558px;
  // height: 280px;
  padding-bottom: 30px;

  // .el-message-box__container {
  //   display: flex;
  //   flex-direction: column;
  //   align-items: center;
  //   justify-content: center;
  // }
  .el-message-box__content {
    margin-bottom: 20px;
  }

  .el-message-box__status {
    display: none;
    // position: relative !important;
    // font-size: 60px !important;
    // color: #005293;
    // margin-top: 30px;
    // margin-bottom: 20px;
  }
  .el-message-box__content {
    .el-message-box__message {
      padding: 0;
      margin: 0;
      font-size: 16px;
      text-align: center;
      p {
        line-height: 32px;
      }
    }
  }
  &.confirm-message-class {
    padding-bottom: 40px !important;
    .el-message-box__message {
      text-align: center;
      font-size: 16px;
      // margin-top: 50px;
      // margin-bottom: 55px;
    }
  }

  .el-message-box__btns {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 0;
    .el-button {
      // width: 130px;
      height: 36px;
      padding: 0 20px;
      // background: #ffffff;
      // border-radius: 21px 21px 21px 21px;
      // opacity: 1;
      // border: 1px solid #005293;
      // &.el-button--primary {
      //   background: #005293;
      //   span {
      //     color: #fff;
      //   }
      // }
      // &:nth-child(2) {
      //   margin-left: 130px;
      // }
      span {
        font-size: 14px;
        font-weight: normal;
        // color: #005293;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue